export default {
  enabledLayers: [],
  mapLayersCache: {},
  enabledZoneLayers: {},
  // TODO: подгрузка типов слоёв с бэка
  layerTypes: {
    platform: 'point',
    source: 'point',
    admterritory: 'multipolygon',
    simplified_admterritory: 'multipolygon',
    separateterritory: 'multipolygon',
    simplified_separateterritory: 'multipolygon',
    transfer: 'multiline',
    simplified_transfer: 'multiline',
    trip: 'multiline',
    simplified_trip: 'multiline',
    round: 'multiline',
    simplified_round: 'multiline',
    flow: 'polyline',
    connections: 'polyline',
    infrastructure: 'point',
  },
  userLayers: [],
  zoneLayers: [],
  createMode: false,
  zoneEditing: null,
  zoneSelectedId: null,
  zoneStats: [],
  zonesToAdd: [],
  mapZones: [],
  zonesToRemove: [],
  activatingLayer: {},
  selectedPeriod: null,
  networkGraph: null
}



// WEBPACK FOOTER //
// ./src/store/workplace/defaults.js